import { connect } from 'react-redux'
import * as action from '../../state/anamnesis/action'
import * as selector from '../../state/anamnesis/selector'

import Anamnesis from '../anamnesis/Anamnesis'
import { selectCustomer } from '../../../customer/state/detail/selector'
import { isIPRProviderStore } from '../../../globals/state/selector'
import { selectUserStore } from '../../../security/state/auth/selector'

const mapStateToProps = (state, { templateKey }) => {
    const customer = selectCustomer(state)
    return {
        ...selector.selectOwnState(state),
        anamnesis: selector.selectAnamnesisByTemplateKey(state, templateKey),
        templateKey,
        customerId: customer.id,
        isUserFromCustomerStore: selectUserStore(state) === customer.store,
        isIPRProviderStore: isIPRProviderStore(state, customer.store),
        showAnamnesis: selector.selectShowAnamnesis(state),
        isInfoLegendShown: selector.selectShowInfoLegendShown(state),
    }
}

const mapDispatchToProps = {
    findOrCreateAnamnesis: action.findOrCreateAnamnesis,
    changeAnamnesis: action.changeAnamnesis,
    udpateAnamnesis: action.udpateAnamnesis,
    saveAnamnesis: action.saveAnamnesis,
    toggleAnamnesis: action.toggleAnamnesis,
    toggleEditingTreatmentExpectation: action.toggleEditingTreatmentExpectation,
    toggleInfoLegend: action.toggleInfoLegend,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Anamnesis)



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/task-widget/AnamnesisEditWidgetContainer.js